<template>
  <div
    v-if="isMounted"
    :key="settings.icon"
    :class="settings.divClass"
  >
    <vx-card title="Case Tracker">
      <!-- CARD ACTION -->
      <template slot="actions">
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer vs-con-dropdown parent-dropdown cursor-pointer self-end"
        >
          <small class="flex cursor-pointer">
            <span>{{ selectedFilter }}</span>
            <feather-icon
              icon="ChevronDownIcon"
              svgClasses="h-4 w-4"
              class="ml-1"
            />
          </small>
          <vs-dropdown-menu class="w-32">
            <vs-dropdown-item @click="getFilteredValue('Last 30 Days')"
              >Last 30 days</vs-dropdown-item
            >
            <vs-dropdown-item @click="getFilteredValue('This Year')"
              >This Year</vs-dropdown-item
            >
            <vs-dropdown-item @click="getFilteredValue('Last Year')"
              >Last Year</vs-dropdown-item
            >
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>

      <div slot="no-body" v-if="supportTracker.analyticsData">
        <div class="vx-row text-center">
          <!-- Open Tickets Heading -->
          <div
            class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last"
          >
            <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
              <h1 class="font-bold text-5xl">
                {{ settings.value.totalCases }}
              </h1>
              <small>Cases</small>
            </div>
          </div>

          <!-- Chart -->
          <div
            class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-right mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6"
          >
            <vue-apex-charts
              ref="realtimeChart"
              type="radialBar"
              height="385"
              :options="supportTrackerRadialBar.chartOptions"
              :series="supportTracker.series"
            />
          </div>
        </div>

        <!-- Support Tracker Meta Data -->
        <div class="flex flex-row justify-between px-8 pb-4 mt-4">
          <p
            class="text-center lg:w-1/4 md:w-full sm:w-1/4"
            v-for="(val, key) in settings.value.meta"
            :key="key"
          >
            <small class="block">{{ val.categoryName }}</small>
            <small class="text-2xl font-semibold">{{ val.total }}</small>
          </p>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "./StatisticsCardLine.vue";
import axios from "@/axios.js";
import { axiosMixin } from "@/mixin/axiosMixin.js"; 
export default {
  data() {
    return {
      selectedFilter: "Last 30 Days",
      isMounted: false,
      supportTracker: {
        analyticsData: {
          openTickets: 163,
          meta: {
            "New Case": 29,
            "Open Case": 63,
            "Response Time": "1d",
          },
        },
        series: [0],
      },
      supportTrackerRadialBar: {
        // chartData: {
        //     totalTickets: 163,
        //     openTickets: 103,
        //     lastResponse: '1d',
        // },
        // series: [83],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 158,
              offsetY: -30,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "65%",
              },
              track: {
                background: "rgba(0,0,0,0)",
                strokeWidth: "100%",
              },
              dataLabels: {
                value: {
                  offsetY: 30,
                  color: "#99a2ac",
                  fontSize: "2rem",
                },
              },
            },
          },
          colors: ["#EA5455"],
          fill: {
            type: "gradient",
            gradient: {
              // enabled: true,
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#7367F0"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          chart: {
            sparkline: {},
          },
          labels: ["Completed Tickets"],
        },
      },
    };
  },

  methods: {
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    getFilteredValue(value) {
      this.selectedFilter = value;
      this.startLoading();

      var filter = {filter:value};
      if(this.settings.hasOwnProperty('clientId')){
        filter['clientId'] =  this.settings.clientId;
      }
 
      this.aronPost(this.settings.filterUrl,filter, "", "")
        .then((response) => {
          if (response.status == 200) {
            this.settings.value = response.data.data;
            this.supportTracker.series =  response.data.data.completedPercentage;
    
            this.$refs.realtimeChart.updateSeries(
              {
                series: response.data.data.completedPercentage,
              },
              false,
              true
            );
          }

          this.closeLoading();
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading();
        });
    },
  },
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    VueApexCharts,
  },
  props: {
    settings: Object,
    default: {},
  },
  created() {
    console.log("settings in cases:", this.settings);
    this.supportTracker.series = this.settings.value.completedPercentage;
    this.isMounted = true;
  },
};
</script>